export default __webpack_public_path__ + "static/media/bg-partenariat-technique.43989fef.webp";